export default __webpack_public_path__ + "static/media/search-icon.1a0d1a38.svg";